// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cD3RdZ4edqd8Pz05PZvm {
    display: flex;
    padding: 20px;
    position: relative;
    overflow-y: hidden;
}

.WfbXGTLuaCF2ksAacoXq {
    position: absolute;
    top: 20px;
    left: 38px;
    width: 0;
    height: 100%;
    border-left: 2px dashed var(--light-gray);
    z-index: -999;
}

.pCTCUI6XE4Nc54fljeGg {
    display: flex;
    background: var(--light-green-background);
    border-radius: 20px;
    padding: 20px;
}

.FRLqTwZcujfnvIigJd3I {
    position: absolute;
    left: 38px;
    top: -20px;
    width: 0;
    height: calc(100% + 40px);
    border-left: 2px dashed var(--light-gray);
    z-index: -999;
}

.yWc0DO11UvAwEU30y_bF {
    position: absolute;
    left: 38px;
    top: -20px;
    width: 0;
    height: 40px;
    border-left: 2px dashed var(--light-gray);
    z-index: -999;
}

.lVKVUd0zgxJjVt9bOojD {
    margin-left: 16px;
}

.lVKVUd0zgxJjVt9bOojD > h4 {
    margin-block-start: 6px;
    margin-block-end: 6px;
}

.lVKVUd0zgxJjVt9bOojD > p {
    margin-block-start: 6px;
    margin-block-end: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/jotpa/JotpaProsessikuvaus.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB","sourcesContent":[".processPhase {\n    display: flex;\n    padding: 20px;\n    position: relative;\n    overflow-y: hidden;\n}\n\n.topLine {\n    position: absolute;\n    top: 20px;\n    left: 38px;\n    width: 0;\n    height: 100%;\n    border-left: 2px dashed var(--light-gray);\n    z-index: -999;\n}\n\n.activePhase {\n    display: flex;\n    background: var(--light-green-background);\n    border-radius: 20px;\n    padding: 20px;\n}\n\n.middleLine {\n    position: absolute;\n    left: 38px;\n    top: -20px;\n    width: 0;\n    height: calc(100% + 40px);\n    border-left: 2px dashed var(--light-gray);\n    z-index: -999;\n}\n\n.bottomLine {\n    position: absolute;\n    left: 38px;\n    top: -20px;\n    width: 0;\n    height: 40px;\n    border-left: 2px dashed var(--light-gray);\n    z-index: -999;\n}\n\n.processInfo {\n    margin-left: 16px;\n}\n\n.processInfo > h4 {\n    margin-block-start: 6px;\n    margin-block-end: 6px;\n}\n\n.processInfo > p {\n    margin-block-start: 6px;\n    margin-block-end: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"processPhase": `cD3RdZ4edqd8Pz05PZvm`,
	"topLine": `WfbXGTLuaCF2ksAacoXq`,
	"activePhase": `pCTCUI6XE4Nc54fljeGg`,
	"middleLine": `FRLqTwZcujfnvIigJd3I`,
	"bottomLine": `yWc0DO11UvAwEU30y_bF`,
	"processInfo": `lVKVUd0zgxJjVt9bOojD`
};
export default ___CSS_LOADER_EXPORT___;
